import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, Link } from 'react-router-dom';
import Moment from 'moment';
import {
  NOTIFICATION_TYPE_OBJECT,
  NOTIFICATION_FREQUENCY_OBJECT,
} from '../const';

export function ScheduledTasksTable({ loading, tasks, onDeleteTask }) {
  const onDelete = useCallback(task => {
    return () => onDeleteTask(task);
  }, []);
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Task Type',
        accessor: 'taskTypeId',
        Cell: row => {
          return (
            <Link
              className="edit-link"
              to={`/scheduled-tasks/edit/${row.original.taskId}`}
            >
              {row.value ? `${NOTIFICATION_TYPE_OBJECT[row.value]}` : row.value}
            </Link>
          );
        },
      },
      {
        Header: 'Task Frequency',
        accessor: 'taskFrequencyId',
        Cell: row => (
          <Link
            className="edit-link"
            to={`/scheduled-tasks/edit/${row.original.taskId}`}
          >
            {row.value
              ? `${NOTIFICATION_FREQUENCY_OBJECT[row.value]}`
              : row.value}
          </Link>
        ),
      },
      {
        Header: 'Task Email',
        accessor: 'taskEmail',
        Cell: row => (
          <Link
            className="edit-link"
            to={`/scheduled-tasks/edit/${row.original.taskId}`}
          >
            {row.value}
          </Link>
        ),
      },
      {
        Header: 'Start Date',
        accessor: 'taskLastStart',
        Cell: row => (
          <Link
            className="edit-link"
            to={`/scheduled-tasks/edit/${row.original.taskId}`}
          >
            {Moment(row.value).format('YYYY/MM/DD')}
          </Link>
        ),
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem
                tag={NavLink}
                to={`/scheduled-tasks/edit/${row.original.taskId}`}
              >
                Edit
              </MuiDropdownItem>
              <MuiDropdownItem tag="a" onClick={onDelete(row.original)}>
                Archive
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ],
    []
  );

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={tasks}
      title="Scheduled Tasks"
      emptyTo="/scheduled-tasks/add"
      resolveData={data => {
        return data.map(tasks => ({
          ...tasks,
        }));
      }}
      getTheadThProps={(_state, _rowInfo, column) => ({
        className: [
          'id',
          'taskTypeId',
          'taskFrequencyId',
          'taskEmail',
          'taskLastStart',
        ].includes(column.id)
          ? 'has-text-left'
          : '',
      })}
      toNext="/people"
      toPrev="/business"
      hideNext
      hidePrev
    />
  );
}

ScheduledTasksTable.propTypes = {
  loading: propTypes.bool.isRequired,
  tasks: propTypes.arrayOf(propTypes.object).isRequired,
  onDeleteTask: propTypes.func.isRequired,
};
